import { render, staticRenderFns } from "./paginationDefault.vue?vue&type=template&id=fd19dbb0"
import script from "./paginationDefault.vue?vue&type=script&lang=js"
export * from "./paginationDefault.vue?vue&type=script&lang=js"
import style0 from "./paginationDefault.vue?vue&type=style&index=0&id=fd19dbb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports